const UrlApi = {

  baseUrl: "https://api.sagio.me/admin/",
  baseUrlImage: "https://api.sagio.me/uploads/",
  // baseUrl: "http://localhost:4000/admin/",
  // baseUrlImage: "http://localhost:4000/uploads/",

  // auth
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },

  admins_logs: {
    get: "admins_logs/get",
    edit: "admins_logs/edit",
  },

  clients: {
    get: "clients/get",
    add: "clients/add",
    edit: "clients/edit",
    delete: "clients/delete",
  },
  blog: {
    get: "blog/get",
    add: "blog/add",
    edit: "blog/edit",
    delete: "blog/delete",
  },

  case_study: {
    get: "case_study/get",
    add: "case_study/add",
    edit: "case_study/edit",
    delete: "case_study/delete",
  },


  slideshow: {
    get: "slideshow/get",
    add: "slideshow/add",
    edit: "slideshow/edit",
    delete: "slideshow/delete",
  },

  what_we_do: {
    get: "what_we_do/get",
    add: "what_we_do/add",
    edit: "what_we_do/edit",
    delete: "what_we_do/delete",
  },

  intro_call: {
    get: "intro_call/get",
    add: "intro_call/add",
    edit: "intro_call/edit",
    delete: "intro_call/delete",
  },

  testimonials: {
    get: "testimonials/get",
    add: "testimonials/add",
    edit: "testimonials/edit",
    delete: "testimonials/delete",
  },

  about_us: {
    get: "about_us/get",
    add: "about_us/add",
    edit: "about_us/edit",
    delete: "about_us/delete",
  },

  features: {
    get: "features/get",
    add: "features/add",
    edit: "features/edit",
    delete: "features/delete",
  },

  settings: {
    get: "settings/get",
    edit: "settings/edit",
  },

  contact_info: {
    get: "settings/get",
    edit: "settings/edit",
  },

  legalInformation: {
    get: "settings/get",
    edit: "settings/edit",
  },

  services: {
    get: "services/get",
    edit: "services/edit",
    add: "services/add",
    delete: "services/delete",
  },

  services_info: {
    get: "services_info/get",
    edit: "services_info/edit",
    add: "services_info/add",
    delete: "services_info/delete",
  },
  projects: {
    get: "projects/get",
    edit: "projects/edit",
    add: "projects/add",
    delete: "projects/delete",
  },

  messages: {
    get: "messages/get",
    delete: "messages/delete",
  },
};

export default UrlApi;
